import React from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import useCustomer from "../Customers/useCustomer";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import swal from "sweetalert";

export default function () {
  const {customerFields, handleSubmit, setErrors} = useCustomer();
  const navigate = useNavigate();

  const addCustomer = data => {
    axios.post('customers', data, {
      headers: {
        'Password-reset': true,
      }
    }).then(function (res) {
      if (res.status == 200) {
        swal('Customer "' + data.first_name + ' ' + data.last_name + '" has been created successfully!', {
          icon: "success",
        });
        navigate("/customers");
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  return (
    <Card title="Add customer">
      <form className="form w-100 row" onSubmit={handleSubmit(addCustomer)}>
        {customerFields}
        <div className="col-12">
          <SubmitButton
            title="Add"
            classes="d-inline-block w-auto"
          />
        </div>
      </form>
    </Card>
  );
}